import * as React from 'react';
import {Box} from "@mui/system";
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';

export default function BasicFilterSelect({input, options, placeholder, onChange, value, textFieldStyle = {}, listBoxHeight = 150, isClearable, loadingOptions, meta: { touched, error } = {}}) {
    const hasError = touched && Boolean(error);

    const handleOnChange = (event, value) => {
        onChange(value);
        input?.onChange(value);
    }

    const noOptionsText = loadingOptions ? "Loading..." : "No options";

    return (
        <Box sx={{position: 'relative'}}>
            {hasError && (
                <Box sx={styles.errorTextContainer}>
                    {error}
                </Box>
            )}
            <Autocomplete
                options={options}
                getOptionLabel={(option) => option.name}
                filterOptions={filterOptions}
                ListboxProps={{ style:  {maxHeight: listBoxHeight, ...styles.listbox}}}
                onChange={handleOnChange}
                value={value}
                disabled={input?.disabled}
                noOptionsText={noOptionsText}
                renderInput={(params) =>
                    <TextField
                        {...params}
                        sx={{
                            ...styles.textField,
                            ...(hasError ? styles.textFieldError : {}),
                            ...textFieldStyle,
                        }}
                        placeholder={placeholder}
                        error={hasError}
                    />
                }
                disableClearable={isClearable}
            />
        </Box>
    );
}

const filterOptions = createFilterOptions({
    matchFrom: 'any',
    stringify: (option) => option.name,
});

const styles = {
    textField: {
        width: '100%',
        fontSize: '16px !important',
        height: '35px',
        fontFamily: 'LarsseitRegular',
        backgroundColor: 'unset !important',
        color: '#0C2728',
        [`& fieldset`]: {
            border: '1px solid #0C2728',
            borderRadius: '5px',
        },
        [`& label`]: {
            fontSize: '16px',
        },
        '& label.Mui-focused': {
            color: '#0C2728',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'green',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderWidth: '1.5px',
                borderColor: '#9EA9A9',
            },
            '&:hover fieldset': {
                borderColor: '#0C2728',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#003300',
            },
        },
        '& .MuiInputBase-input': {
            height: '8px',
        },
        'input': {
            '&::placeholder': {
                fontFamily: 'LarsseitRegular',
            }
        }
    },
    textFieldError: {
        "& fieldset": {
            border: "1px solid #EB5757",
        },
    },
    errorTextContainer: {
        fontSize: '13px',
        fontFamily: "LarsseitRegular",
        color: "#da5151",
        position: 'absolute',
        top: '-25px',
        right: '0'
    },
    listbox: {
        fontFamily: 'LarsseitRegular',
    }
};